<template>
  <div class="relative w-full h-auto">
    <img
      src="/images/bg-white.jpg"
      alt="Background"
      class="w-full h-[600px] lg:max-h-[500px] object-cover"
    />
    <div
      class="absolute inset-0 bg-gradient-to-l from-[#1450A0] to-[#E72B6F] opacity-80"
    ></div>
    <div
      class="absolute inset-0 flex items-center justify-center text-white z-10"
    >
      <div class="container mx-auto px-5">
        <div class="flex flex-col lg:flex-row gap-10 items-center">
          <div class="w-full lg:w-1/2 text-center lg:text-start">
            <h1
              class="flex items-center justify-center w-full font-extrabold text-3xl lg:text-4xl leading-9"
            >
              {{ t("reviews.title") }}
            </h1>

            <p class="mt-6">
              {{ t("reviews.description") }}
            </p>
          </div>

          <div class="w-full lg:w-1/2 max-w-lg lg:ml-auto">
            <Swiper
              :modules="[EffectCreative, Pagination]"
              :effect="'creative'"
              :creativeEffect="{
                prev: {
                  translate: ['-120%', 0, -500],
                },
                next: {
                  translate: ['120%', 0, -500],
                },
              }"
              :slides-per-view="1"
              space-between="30"
              :pagination="{ clickable: true }"
              :grab-cursor="true"
            >
              <SwiperSlide v-for="item in reviews" class="p-4 mx-auto">
                <div class="bg-white rounded-sm shadow-lg p-12">
                  <div class="text-brand-gray text-sm mb-4">
                    {{ item.review }}
                  </div>
                  <div class="flex justify-between gap-3">
                    <div>
                      <div class="font-bold text-black">{{ item.name }}</div>
                      <div class="text-brand-gray text-sm">
                        {{ item.role }}
                      </div>
                    </div>
                    <div>
                      <nuxt-img
                        src="/images/aphostrophe.png"
                        class="w-10 object-contain"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Pagination, EffectCreative } from "swiper/modules";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const reviewKeys = ["first", "second", "third", "fourth"];

const reviews = computed(() =>
  reviewKeys.map((key) => ({
    review: t(`reviews.${key}.review`),
    name: t(`reviews.${key}.name`),
    role: t(`reviews.${key}.role`),
  }))
);
</script>
